import React from "react";
import withAULayout from "../../../components/au.desktop/layout";
import ErrorHandler from "../../../components/shared/with-error-handler";
import MyAccountWrapper from "../../../components/au.desktop/my-account-wrapper";
import StaticPageMeta from "../../../components/shared/meta-tags/static-meta";
import { STATIC_META_CONSTANTS } from "../../../constants/meta-static-page";

const MyAccount = () => {
    return (
        <React.Fragment>
            <StaticPageMeta type={STATIC_META_CONSTANTS.MY_ACCOUNT} />
            <ErrorHandler>
                <MyAccountWrapper />
            </ErrorHandler>
        </React.Fragment>
    );
};

export default withAULayout(MyAccount, true, false, {headerProps: {fixed: true}});
